import axios, { AxiosResponse } from 'axios';
import { BaseService } from './BaseService';
import { Campus, Widget } from './types/organization';
import SchoolService from '~/services/SchoolService';

export * from './types/organization';

export default class OrganizationService extends BaseService {
    constructor() {
        super('content/organization');
    }

    async getCampuses(schoolId: string): Promise<Campus[]> {
        return axios({
            method: 'GET',
            url: this.getUrl(`campuses/${schoolId}`),
        }).then(res => res.data);
    }

    async getGlobalWidgets(): Promise<Widget[]> {
        return this.getWidgets(true, true);
    }

    async getSchoolWidgets(): Promise<Widget[]> {
        return this.getWidgets(false, false);
    }

    async getWidgets(includeGlobal = false, excludeSchool = false): Promise<Widget[]> {
        const params = {
            includeInactive: false,
            schoolIds: undefined as number | undefined | null,
            includeGlobal: includeGlobal,
        };

        if (excludeSchool) {
            params.schoolIds = null;
        } else {
            const schoolId = SchoolService.getCurrentSchoolId();
            if (typeof schoolId !== 'number') throw new Error('Could not get current school id');
            params.schoolIds = schoolId;
        }

        return axios({
            method: 'GET',
            url: this.getUrl(`widgets`),
            params,
        }).then((result: AxiosResponse<Widget[]>) => result.data);
    }
}
